import React, { useState, useEffect, useCallback } from "react";
import { getCurrentDate, getOnePreviousDate } from "../../Utilitie";
import { FaEraser, FaUpload } from "react-icons/fa";
import Loading from "../../Extra/Loading";
import { MdInsertChart } from "react-icons/md";
import SuccessMsg from "../../Extra/SuccessMsg";
import FailedMsg from "../../Extra/FailedMsg";
import { useGlobalContext } from "../../Context/GlobalContext";

// const sections = [
//   "JABALPUR JN.",
//   "NEW KATNI JN.",
//   "SATNA JN.",
//   "SAUGOR",
//   "BEOHARI",
//   "SINGRAULI",
//   "SECR",
// ];

const secMap = {
  NKJ: "NEW KATNI JN.",
  SGO: "SAUGOR",
  STA: "SATNA JN.",
  SECR: "SECR",
  JBP: "JABALPUR JN.",
  BEHR: "BEOHARI",
  SGRL: "SINGRAULI",
};

const emptyRow = (id, date, section = "") => ({
  id,
  date,
  section,
  trains_count: 0,
  avg_time: "00:00",
  total_time: 0,
});

const PDDUpdate = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const { userData } = useGlobalContext();
  const [rows, setRows] = useState(7);
  const [gridData, setGridData] = useState(() =>
    Array.from({ length: 7 }, (_, i) => emptyRow(i + 1, getCurrentDate()))
  );

  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [show, setShow] = useState(false);
  const [globalDate, setGlobalDate] = useState(getCurrentDate());
  const [PDDData, setPDDData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  /** ---------- Fetch Section Data ---------- **/
  const fetchSections = useCallback(async () => {
    try {
      setLoading(true);
      const res = await fetch(`${urlPrefix}getstationcode`);
      const data = await res.json();
      setSectionData(data.data || []);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [urlPrefix]);

  useEffect(() => {
    fetchSections();
  }, [fetchSections]);
  /** ---------- Fetch PDD Data ---------- **/
  const fetchPDD = useCallback(async () => {
    try {
      setLoading(true);
      const url = `${urlPrefix}pdd?date=${globalDate || getOnePreviousDate()}`;
      const res = await fetch(url, {
        headers: { Authorization: `Bearer ${localStorage.token}` },
      });
      const data = await res.json();
      if (data.status === "ok") {
        const a = data.data.find((o) => o.filtered_by === "date");
        setPDDData(Array.isArray(a?.current?.data) ? a.current.data : []);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }, [globalDate, urlPrefix]);

  useEffect(() => {
    fetchPDD();
  }, [fetchPDD]);

  /** ---------- Fill Grid From API ---------- **/
  useEffect(() => {
    if (!PDDData.length) return;
    setGridData(
      PDDData.filter((r) => secMap[r.station_code]).map((row, i) => ({
        id: row.id,
        date: globalDate,
        section: secMap[row.station_code] || row.station_code,
        trains_count: Number(row.total_trains_count) || 0,
        avg_time: (row.avg_avg_time || "00:00").slice(0, 5),
        total_time: Number(row.total_total_time) || 0,
      }))
    );
  }, [PDDData, globalDate]);

  /** ---------- Update a Cell ---------- **/
  const handleChange = (i, key, value) => {
    setGridData((prev) => {
      const upd = [...prev];
      upd[i] = { ...upd[i], [key]: value };
      if (key === "trains_count" || key === "avg_time") {
        const t = Number(upd[i].trains_count);
        const [h = 0, m = 0] = upd[i].avg_time.split(":").map(Number);
        upd[i].total_time = t * (h * 60 + m);
      }
      return upd;
    });
  };
  const FinalData = gridData.map(({ date, section, ...rest }) => rest);
  /** ---------- Upload ---------- **/
  const sendToBackend = async () => {
    const FinalData = gridData.map(({ date, section, ...rest }) => rest);
    setLoading(true);
    try {
      const res = await fetch(`${urlPrefix}pddupdate`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ records: FinalData }),
      });
      const data = await res.json();
      setResult(data);
      setShow(true);
      if (data.status === "ok");
    } catch (e) {
      setResult({ status: "failed", message: e.message });
      setShow(true);
    } finally {
      setLoading(false);
    }
  };
  const toHHMM = (min) =>
    `${String(Math.floor(min / 60)).padStart(2, "0")}:${String(
      min % 60
    ).padStart(2, "0")}`;

  return (
    <div className="container mt-3">
      <h4>
        <MdInsertChart /> PDD UPDATE
      </h4>

      {loading && <Loading />}
      <table className="table table-striped table-hover">
        <thead className="table-dark">
          <tr>
            <th>Date</th>
            <th>Section</th>
            <th>Trains Count</th>
            <th>Avg Time</th>
            <th>Total Time</th>
          </tr>
        </thead>
        <tbody>
          {gridData.map((r, i) => (
            <tr key={r.id}>
              <td>
                <input
                  type="date"
                  value={globalDate}
                  max={getCurrentDate()}
                  onChange={(e) => setGlobalDate(e.target.value)}
                />
              </td>
              <td>
                {PDDData.length > 0 && (
                  <input value={r.section} readOnly className="form-control" />
                )}
              </td>
              <td>
                {PDDData.length > 0 && (
                  <input
                    type="number"
                    value={r.trains_count}
                    onChange={(e) =>
                      handleChange(i, "trains_count", Number(e.target.value))
                    }
                    className="form-control"
                  />
                )}
              </td>
              <td>
                {PDDData.length > 0 && (
                  <input
                    type="time"
                    value={r.avg_time}
                    onChange={(e) =>
                      handleChange(i, "avg_time", e.target.value)
                    }
                    className="form-control"
                  />
                )}
              </td>
              <td>
                {PDDData.length > 0 && (
                  <input
                    value={toHHMM(r.total_time)}
                    readOnly
                    className="form-control"
                  />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {PDDData.length > 0 && (
        <div className="text-center">
          <button
            className="btn btn-sm btn-outline-success m-1"
            onClick={sendToBackend}
          >
            <FaUpload /> Upload
          </button>
        </div>
      )}

      {result &&
        (result.message ===
        "✅ Records and overall stats updated successfully" ? (
          <SuccessMsg
            show={show}
            setShow={setShow}
            head="Success"
            message={result.message}
          />
        ) : (
          <FailedMsg
            show={show}
            setShow={setShow}
            head="Failed"
            message={result.message}
          />
        ))}
    </div>
  );
};
export default PDDUpdate;
